import React from 'react';
import styled from 'styled-components/macro';
import SortMenu from '../Cards/SortMenuPlaceholder';
import { GalleryCardPlaceholder } from '../Cards/GalleryCardPlaceholder';
import { PaginationPlaceholder } from '../Cards/PaginationPlaceholder';

type Props = {
  count?: number;
  detailed?: boolean;
};

const LoaderWrapper = (props: Props) => {
  const { count = 30 } = props;

  const renderCards = () => (
    <CardsWrap>
      {[...Array(count)].map((elem, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <GalleryCardPlaceholder key={i} />
      ))}
    </CardsWrap>
  );

  const sortMenu = <SortMenu />;
  const galleryCards = renderCards();
  const pagination = <PaginationPlaceholder />;

  return (
    <div className="placeholder-wrap">
      {sortMenu}
      {galleryCards}
      {pagination}
    </div>
  );
};

const CardsWrap = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export default LoaderWrapper;
